import { LifecycleStage } from './LifecycleStage';

/** v7.5: reviewed cross-system lifecycle view. */
export function ReleaseStage() { return <LifecycleStage stage="release" />; }
